import { Component, Input, OnInit, ChangeDetectorRef } from "@angular/core";
import { SharedFormService } from "src/app/shared-utility/services/shared-form.service";
import { ToastrService } from "ngx-toastr";
import { SharedStateService } from "src/app/shared-utility/services/shared-state.service";
import { Router } from "@angular/router";
import { Title } from "@angular/platform-browser";


@Component({
  selector: 'app-patient-esignature-authorization',
  templateUrl: './patient-esignature-authorization.component.html',
  styleUrls: ['./patient-esignature-authorization.component.scss']
})
export class PatientEsignatureAuthorizationComponent implements OnInit {
 
  constructor(
    private formDataSvc: SharedFormService,
    private toastr: ToastrService,
    private sharedStateSvc: SharedStateService,
    private router: Router,
    private formData: SharedFormService,
    private title: Title,
    private cdr: ChangeDetectorRef
  ) {
    this.title.setTitle("Patient eSignature | ViiVConnect");
   }

  ngOnInit() {

    window.postMessage = (msg) => {
      if (msg === "closePatientIframe") {
        setTimeout(() => {
          this.showIframe = false;
          this.iFrameInit = false;
          this.cdr.detectChanges();
        }, 1000);
      }
    };
    
  }
  iFrameInit:boolean=false;
  zipCode1:any='';
  patientDOB = null;
  patientLastName1:any='';
  patientFirstName1:any='';
  EconsentSignedBy: string = "";
  patientEmail: string;
  relationToPatient: string = "";
  caregiverFirstName: string = "";
  caregiverLastName: string = "";
  showCaregiverOptions: boolean = false;
  showFirstNameError:boolean=false;
  showIframe: boolean = false;
  todaysDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getUTCDate(),
  };

  docuSignUrl:string= "";

  onSubmitEsignForm(FormVal){
    let econsentDetailPayload = {
      SourceSite: 1,
      Consumer: {
        FirstName: this.patientFirstName1,
        LastName: this.patientLastName1,
        Email: this.patientEmail,
        Zip: this.zipCode1,
        DOB:  this.formatDOB(), //mmddyyyy
        Source: "Portal",
        AuthBy: this.EconsentSignedBy,
      }
    }
    if (this.EconsentSignedBy == "Caregiver"){
      econsentDetailPayload.Consumer["PatientOrPatientRep"] =  {
          FirstName: this.caregiverFirstName,
          LastName: this.caregiverLastName,
          RelationshipToPatient: this.relationToPatient,
      }
      // econsentDetailPayload.Consumer.push('PatientOrPatientRep' : {
      //     FirstName: this.caregiverName,
      //     LastName: this.caregiverName,
      //     RelationshipToPatient: this.relationToPatient,
      // })
    }
    this.formData.hideLoader.next(true);
    /*
    * Commenting it as per changes in Econsent API Payload structure by mule team

    this.sharedStateSvc.getEconsentAuthentication().subscribe((res)=>{
      if(res && res.Status==='SUCCESS'){
        let AuthorizationToken: string = "Bearer " + res.Payload.access_token; 
        this.sharedStateSvc.postEconsentDetails(AuthorizationToken, econsentDetailPayload).subscribe((consentRes) => {
          this.docuSignUrl = consentRes.Payload.DocusignURL;
          this.formData.hideLoader.next(false);
          this.iFrameInit = true;
          this.showIframe=  true;
        });
    let AuthorizationToken: string = "Bearer " + consentRes.Payload.access_token; 
    */
    this.sharedStateSvc.postEconsentDetails(econsentDetailPayload).subscribe((consentRes) => {
      if(consentRes && consentRes.Status==='SUCCESS'){
          this.docuSignUrl = consentRes.Payload.DocusignURL;
          this.formData.hideLoader.next(false);
          this.iFrameInit = true;
          this.showIframe=  true;
           FormVal.reset();
      }else{
        this.formData.hideLoader.next(false);
        this.toastr.error('Failed to get URL')
      }
    },(error)=>{
      this.formData.hideLoader.next(false);
      this.toastr.error('Failed to get URL')
    })
  }

  validZip:boolean=false;
  eSignatureFormValues(FormVal){
      if (this.EconsentSignedBy == "Caregiver"){
        this.showCaregiverOptions=true;
      }
      else{
        this.showCaregiverOptions = false;
      }
      this.zipCode1=FormVal.value.zipCode;
      if(this.zipCode1===''){
        this.validZip=false;
      }
      else if(this.zipCode1.length===5){
        this.validZip=true;
      }else{
        this.validZip=false;
      }
      this.patientLastName1=FormVal.value.patientLastName;
      this.patientFirstName1=FormVal.value.patientFirstName;
      if(this.patientFirstName1==''){
          this.showFirstNameError=true;
      }else{
        this.showFirstNameError=false;
      }
     
  }
  formatDOB():string{
    //010 07 2023
    let month: string = this.patientDOB.month >= 10 ? this.patientDOB.month.toString() : '0' + this.patientDOB.month.toString();
    let day: string = this.patientDOB.day >= 10 ? this.patientDOB.day.toString() : '0' + this.patientDOB.day.toString();
    return month + day + this.patientDOB.year.toString();
  }
  redirectCheck(){
    this.router.navigate(["/redirect-patient-esignature-authorization"]);
  }
  check(){
    this.iFrameInit=true;
  }
  ngOnDestroy(): void {
    this.title.setTitle(" HCP Portal | ViiVConnect ");
  }
}
